@if (!isProd) {
  <span class="test-label pe-none text-danger">
    @if (isTest) {
      검증
    }
    @if (isDev) {
      개발
    }
  </span>
}

<router-outlet (activate)="onActivate()" />

@if (!isInitialActivate) {
  <loading />
}

<div class="dialog-wrapper">
  @for (dialogRef of dialogService.dialogRefList(); track dialogRef.id) {
    <ng-template
      [ngComponentOutlet]="dialogRef.type"
      [ngComponentOutletInputs]="{ dialogRef: dialogRef }"
    ></ng-template>
  }
</div>
